export const FETCH_COLLECTIONS = {
  init: 'collections/FETCH_COLLECTIONS/init',
  request: 'collections/FETCH_COLLECTIONS/request',
  success: 'collections/FETCH_COLLECTIONS/success',
  failure: 'collections/FETCH_COLLECTIONS/failure',
  cancel: 'collections/FETCH_COLLECTIONS/cancel',
  clear: 'collections/FETCH_COLLECTIONS/clear',
} as const;

export const FETCH_COLLECTION_INFO = {
  init: 'collections/FETCH_COLLECTION_INFO/init',
  request: 'collections/FETCH_COLLECTION_INFO/request',
  success: 'collections/FETCH_COLLECTION_INFO/success',
  failure: 'collections/FETCH_COLLECTION_INFO/failure',
  cancel: 'collections/FETCH_COLLECTION_INFO/cancel',
} as const;

export const COLLECTIONS_STORE_NAME = 'collections' as const;
